function FooterMenus() {
  const menuTriggers = document.querySelectorAll('.footer__menu h6');

  menuTriggers.forEach((button) => {
    button.addEventListener('click', () => {
      const Menu = button.nextElementSibling;
      button.classList.toggle('open');
      Menu.classList.toggle('open');
    });
  });
}

export default FooterMenus;
